module.exports = __webpack_public_path__ + "img/ranger-dot-com.2ea9d35b.svg";